import { createAction, createApiAction } from '@saucelabs/sl-util-redux';
import { api } from '@saucelabs/sl-module-invitation';

import * as types from './types';

export const getInvitation = createApiAction(
  types.GET_INVITATION,
  (payload) => api.getInvitation(payload),
);

export const acceptInvitation = createApiAction(
  types.ACCEPT_INVITATION,
  (payload) => api.acceptInvitation(payload),
);

export const moveInvitation = createApiAction(
  types.MOVE_INVITATION,
  (payload) => api.moveInvitation(payload),
);

export const declineInvitation = createApiAction(
  types.DECLINE_INVITATION,
  (payload) => api.declineInvitation(payload),
);

export const cleanup = createAction(types.CLEANUP);
